interface Props {
  size: number;
  color?: string;
  strokeWidth?: number;
}

export function SpinningCircle(props: Props) {
  const size = props.size || 20;
  const width = size;
  const height = size;
  const strokeWidth = props.strokeWidth || 38 / width;
  const color = props.color || 'gray';
  return (
    <svg width={width} height={height} viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke={color}>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(1 1)" strokeWidth={strokeWidth}>
          <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
          <path d="M36 18c0-9.94-8.06-18-18-18">
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 18 18"
              to="360 18 18"
              dur="1s"
              repeatCount="indefinite"
            />
          </path>
        </g>
      </g>
    </svg>
  );
}
